import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { BehaviorSubject, Observable } from "rxjs";
import { ProfileModel } from "../models";
import { RoleTypes } from "../models/role";
import { decodeToken } from "../utils/jwt-helper";

type UserProfileModel = ProfileModel | null | undefined;

@Injectable({
  providedIn: "root"
})
export class AccountService {
  // todo: rename to UserProfileService
  private user$: BehaviorSubject<UserProfileModel> = new BehaviorSubject<UserProfileModel>(null);
  private readonly roleLevels = [RoleTypes.Sales, RoleTypes.LocationManager, RoleTypes.Manager, RoleTypes.PartnerAdmin, RoleTypes.Admin];

  userChanged$: Observable<UserProfileModel> = this.user$.asObservable();

  constructor(private oAuthService: OAuthService) {}

  get isLoggedIn(): boolean {
    return this.oAuthService.hasValidAccessToken();
  }

  get user(): UserProfileModel {
    if (this.accessToken) {
      return decodeToken(this.accessToken);
    }
    return undefined;
  }

  get userId() {
    let userId = null;
    if (this.isLoggedIn && this.user?.sub) {
      userId = +this.user.sub;
    }
    return userId;
  }

  // Used to access user information
  get idToken(): string {
    return this.oAuthService.getIdToken();
  }

  get accessToken(): string {
    return this.oAuthService.getAccessToken();
  }

  public isUserInRole(role: RoleTypes): boolean {
    return this.isLoggedIn && this.user?.role === role;
  }

  public isUserRequireMinRole(role: RoleTypes): boolean {
    if (!this.isLoggedIn) return false;
    const requiredRoleIndex = this.roleLevels.indexOf(role);
    const userRoleIndex = this.roleLevels.indexOf(this.user?.role as RoleTypes);
    return requiredRoleIndex <= userRoleIndex;
  }

  public refreshUser(user: UserProfileModel): void {
    this.user$.next(user);
  }
}
